import { format } from 'date-fns';
const statuses = {
  1: 'Zaprimljeno',
  2: 'U obradi',
  3: 'Odbijeno',
  4: 'Riješeno',
}

const orderStatuses = [
  {
    id: -1,
    label: 'Prednarudžba',
  },
  {
    id: 1,
    label: 'Kreirano',
  }, {
    id: 2,
    label: 'Odobreno',
  }, {
    id: 3,
    label: 'Otkazano',
  }, {
    id: 4,
    label: 'Završeno',
  }, {
    id: 5,
    label: 'Završeno (isporučeno)'
  },
  {
    id: 6,
    label: 'Otkazano - spojeno'
  },
  {
    id: 7,
    label: 'Otkazano - razdvojeno'
  },
  {
    id: 8,
    label: 'Neisporučeno'
  },
  {
    id: 9,
    label: 'Kreirano - neplaćeno'
  },
  {
    id: 10,
    label: 'Plaćeno'
  },
];

const statusesArray = [{
  id: 1,
  title: 'Zaprimljeno',
}, {
  id: 2,
  title: 'U obradi',
}, {
  id: 3,
  title: 'Odbijeno',
}, {
  id: 4,
  title: 'Riješeno',
}];

const problemTypes = {
  '-1': 'Nepoznat',
  1: 'Reklamacija proizvoda',
  2: 'Tehnički kvar',
};

const problemTypesArray = [{
  id: '-1',
  title: 'Nepoznat',
}, {
  id: 1,
  title: 'Reklamacija proizvoda',
}, {
  id: 2,
  title: 'Tehnički kvar'
}];

const articleStates = [{
    id: 1,
    label: 'Importano',
  }, {
    id: 2,
    label: 'Nezavršeno',
  }, {
    id: 3,
    label: 'Završeno',
  }, {
    id: 4,
    label: 'Importano - CSV'
  }
];

const mediaFileTypes = {
  IMAGE: 1,
  PDF: 2,
};

const deliveryTypes = {
  PERSONAL_TAKING: 1,
  EXPRESS_POST: 2,
  OUR_DELIVERY: 3,
};

const PaymentType = {
  Gotovina: 1,
  Kartica: 2,
  Virman: 3,
  PoPouzecu: 4,
};

const {
  Gotovina, Kartica, Virman, PoPouzecu, 
} = PaymentType;

const PaymentTypeTranslations = {
  [Gotovina]: 'Gotovina',
  [Kartica]: 'Kartica',
  [Virman]: 'Virman',
  [PoPouzecu]: 'Po pouzeću'
}

const paymentTypesArray = [{
    id: Gotovina,
    label: 'Gotovina'
  }, {
    id: Kartica,
    label: 'Kartica',
  }, {
    id: Virman,
    label: 'Virman',
  }
];

const b2cPaymentTypesArray = [
  {
    id: PoPouzecu,
    label: 'Po pouzeću',
  },
  {
    id: Kartica,
    label: 'Kartično plaćanje',
  }
];

const { PERSONAL_TAKING, EXPRESS_POST, OUR_DELIVERY } = deliveryTypes;

const deliveryTypeTranslations = {
  [PERSONAL_TAKING]: 'Lično preuzimanje',
  [EXPRESS_POST]: 'Brza pošta',
  [OUR_DELIVERY]: 'Naša dostava',
};

const PageTypes = {
  Homepage: 1,
  Brands: 2,
  Actions: 3,
  Blogs: 4,
  About: 5,
  Contact: 6
};

const languages =  [
  { id: 'bs', label: 'Bosanski' },
  { id: 'hr', label: 'Hrvatski' },
  { id: 'srLatn', label: 'Srpski (lat)' },
  { id: 'srCyrl', label: 'Srpski (ćir)' },
  { id: 'en', label: 'English' },
];

const hasPermission = (permission, permissionArr) => {
  return permissionArr?.includes(permission);
}


const parseApiDate = (date) => {
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}T[\d:.]+$/.test(date)) {
    return new Date(`${date}Z`);
  }

  return new Date(date);
}

export default {
  buildSidebarNav() {
    // Navigation
    const $items = $('.nav-main li.nav-parent');

    function expand($li) {
      $li.children('ul.nav-children').slideDown('fast', function () {
        $li.addClass('nav-expanded');
        $(this).css('display', '');
        ensureVisible($li);
      });
    }

    function collapse($li) {
      $li.children('ul.nav-children').slideUp('fast', function () {
        $(this).css('display', '');
        $li.removeClass('nav-expanded');
      });
    }

    function ensureVisible($li) {
      const scroller = $li.offsetParent();
      if (!scroller.get(0)) {
        return false;
      }

      const top = $li.position().top;
      if (top < 0) {
        scroller.animate({
          scrollTop: scroller.scrollTop() + top
        }, 'fast');
      }
    }

    function buildSidebarNav(anchor, prev, next, ev) {
      if (anchor.prop('href')) {
        const arrowWidth = parseInt(window.getComputedStyle(anchor.get(0), ':after').width, 10) || 0;
        if (ev.offsetX > anchor.get(0).offsetWidth - arrowWidth) {
          ev.preventDefault();
        }
      }

      if (prev.get(0) !== next.get(0)) {
        collapse(prev);
        expand(next);
      } else {
        collapse(prev);
      }
    }

    $items.find('> a').on('click', function (ev) {

      const $html = $('html'),
        $window = $(window),
        $anchor = $(this),
        $prev = $anchor.closest('ul.nav').find('> li.nav-expanded'),
        $next = $anchor.closest('li'),
        $ev = ev;

      if ($anchor.attr('href') == '#') {
        ev.preventDefault();
      }

      if (!$html.hasClass('sidebar-left-big-icons')) {
        buildSidebarNav($anchor, $prev, $next, $ev);
      } else if ($html.hasClass('sidebar-left-big-icons') && $window.width() < 768) {
        buildSidebarNav($anchor, $prev, $next, $ev);
      }

    });

    $('.nav-main').on('touchend', function (e) {
      const $target = $(e.target);

      if ($target.closest('li').hasClass('nav-parent')) {
        setTimeout(function () {
          $('html').removeClass('sidebar-left-collapsed');
          $('.content-body').trigger('click');
        }, 100);
      } else {
        if ($target.closest('a').attr('href')) {
          window.location.href = $target.closest('a').attr('href');
        }
      }
    });

    // Chrome Fix
    $.browser.chrome = /chrom(e|ium)/.test(navigator.userAgent.toLowerCase());
    if ($.browser.chrome && !$.browser.mobile) {
      let flag = true;
      $('.sidebar-left .nav-main li a').on('click', function () {
        flag = false;
        setTimeout(function () {
          flag = true;
        }, 200);
      });

      $('.nano').on('mouseenter', function () {
        $(this).addClass('hovered');
      });

      $('.nano').on('mouseleave', function () {
        if (flag) {
          $(this).removeClass('hovered');
        }
      });
    }
  },
  generateRange(start, end) {
    return Array(end - start + 1).fill().map((_, idx) => start + idx);
  },
  generateCategories(categories) {
    const newCategories = categories.map((item) => ({
      ...item,
      childVisible: false,
    }));

    return newCategories;
  },
  normalizer(node) {
    return {
      id: node.id,
      label: node.title,
      children: node.children,
    };
  },
  mapProblemStatus(id) {
    return statuses[id];
  },
  getProblemStatusesAsArray() {
    return statusesArray;
  },
  mapProblemType(id) {
    return problemTypes[id];
  },
  getProblemTyles() {
    return problemTypesArray;
  },
  mapProblemStatusClass(id) {
    switch(id) {
      case 1: return 'badge bg-secondary';
      case 2: return 'badge bg-warning text-dark';
      case 3: return 'badge bg-danger';
      case 4: return 'badge bg-success';
      case 6: return 'badge bg-danger';
      case 7: return 'badge bg-danger';
    }
  },
  mapOrderStatusCssClass(id) {
    switch(id) {
      case 1: return 'badge bg-warning text-dark';
      case 2: return 'badge bg-primary';
      case 3: return 'badge bg-danger';
      case 4: return 'badge bg-success';
      case 5: return 'badge bg-success';
      case 6: return 'badge bg-danger';
      case 7: return 'badge bg-danger';
      case 8: return 'badge bg-danger';
      case 9: return 'badge bg-warning text-dark'
      case 10: return 'badge bg-success'
      default: return 'badge bg-warning text-dark';
    }
  },
  mapOrderStatus(status) {
    return ((orderStatuses.find((item) => item.id === status) || {}).label) || 'N/A';
  },
  formatDate(date = new Date(), dateFormat = 'dd.MM.yyyy HH:mm') {
    return format(parseApiDate(date), dateFormat);
  },
  formatDateForApi(date) {
    if (!date) {
      return null;
    }

    return format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss");
  },
  hasPermission,
  articleStates,
  orderStatuses,
  mediaFileTypes,
  deliveryTypes,
  deliveryTypeTranslations,
  PaymentType,
  PaymentTypeTranslations,
  paymentTypesArray,
  b2cPaymentTypesArray,
  PageTypes,
  languages
};
